module.exports = __webpack_public_path__ + "static/img/b1-1-1.c8e2e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-1-1.png
// module id = GPwI
// module chunks = 1